import firebase from 'firebase'
export const createAnnouncement = (announcement) => {
    return(dispatch, getState, {getFirebase, getFirestore})=>{
        const firestore = getFirestore();
        var user = firebase.auth().currentUser;
        const authorId= getState().firebase.auth.uid;
        
        firestore.collection('projects').add({
            ...announcement ,
            authorId: authorId,
            useremail :user.email,
            name : user.displayName,
            createdAt: new Date()
        }).then(()=>{
       
            dispatch({type :'CREATE_ANNOUNCEMENT', announcement});
     
        }).catch((err)=>{
            dispatch({type :'CREATE_ANNOUNCEMENT_ERROR',err});
        })

    };
};


